import { render } from "./FaceRecognitionFailed.vue?vue&type=template&id=560a60c0&scoped=true"
import script from "./FaceRecognitionFailed.vue?vue&type=script&lang=js"
export * from "./FaceRecognitionFailed.vue?vue&type=script&lang=js"

import "@/assets/css/idcheck/face/style.css?vue&type=style&index=0&id=560a60c0&scoped=true&lang=css&external"
import "./FaceRecognitionFailed.vue?vue&type=style&index=1&id=560a60c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560a60c0"]])

export default __exports__